import React from 'react';
import { Checkbox, FormGroup } from 'react-bootstrap';

const ITEMS_NEEDED_TO_DESIGNATE_GC = [
    {
        key: 'DGC1',
        text:
            'Fully executed contract containing hh/indem/ai language in favor of our Named Insured.',
        sortOrder: 1,
        completed: false
    },
    {
        key: 'DGC2',
        text: 'COI with minimum required limits.',
        sortOrder: 2,
        completed: false
    },
    {
        key: 'DGC3',
        text: 'Copy of contractor\'s GL & XS policies.',
        sortOrder: 3,
        completed: false
    },
    {
        key: 'DGC4',
        text:
            'Requirement for contractor to maintain PCO limits up to statute in Executed Contract or endorsed on Project Policy.',
        sortOrder: 4,
        completed: false
    },
    {
        key: 'DGC5',
        text:
            'Copy of specifically named (not blanket) CG2010 and CG2037 from the direct hired contractor.',
        sortOrder: 5,
        completed: false
    },
    {
        key: 'DGC6',
        text:
            'Confirmation of blanketed CG2010 and CG2037 forms on the direct hired contractor\'s GL Policy.',
        sortOrder: 6,
        completed: false
    }
];

export const VALID_BASE_COVERAGES = ['standard', 'deductibleWarranty'];

export class GCList extends React.Component {
    constructor(props) {
        super(props);
        this.title = 'Items Needed to Designate the General Contractor';

        this.state = {
            designateGCList: getDesignateGCList(
                this.props.submission.ratings[this.props.type],
                this.props.coverage,
                this.props.type,
                this.props.submission,
                this.props.additionalCoverage,
                this.props.excessLimitAmount
            )
        };
        this.handleCheckBox = this.handleCheckBox.bind(this);
    }

    componentDidMount() {
        if (designatedContractorsIsApplicable(this.props.coverage, this.props.type)) {
            this.props.onBlurHandler({
                designatedContractors: this.state.designateGCList
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.coverage !== this.props.coverage ||
            JSON.stringify(prevProps.additionalCoverage) !==
                JSON.stringify(this.props.additionalCoverage) ||
            prevProps.excessLimitAmount !== this.props.excessLimitAmount
        ) {
            this.setState(
                {
                    designateGCList: getDesignateGCList(
                        this.props.submission.ratings[this.props.type],
                        this.props.coverage,
                        this.props.type,
                        this.props.submission,
                        this.props.additionalCoverage,
                        this.props.excessLimitAmount
                    )
                },
                () => {
                    this.props.onBlurHandler({
                        designatedContractors: this.state.designateGCList
                    });
                }
            );
        }
    }

    handleCheckBox(key, event) {
        const { checked } = event.target;
        const designateGCListCopy = [...this.state.designateGCList];
        for (let i = 0; i < designateGCListCopy.length; i += 1) {
            if (designateGCListCopy[i].key === key) {
                designateGCListCopy[i] = {
                    ...designateGCListCopy[i],
                    completed: checked
                };
                break;
            }
        }
        this.setState({
            designateGCList: designateGCListCopy
        });

        this.props.onBlurHandler({
            designatedContractors: designateGCListCopy
        });
    }

    render() {
        const { designateGCList } = this.state;
        if (designateGCList.length === 0) {
            return null;
        }
        return (
            <div className="designatedGCContainer">
                <div className="list-header">
                    <h4 className="list-title">{this.title}</h4>
                </div>

                <FormGroup className="checkbox-group">
                    {designateGCList.map(item => {
                        return (
                            <Checkbox
                                key={item.key}
                                onChange={event => this.handleCheckBox(item.key, event)}
                                checked={item.completed}
                            >
                                <div>{item.text}</div>
                            </Checkbox>
                        );
                    })}
                </FormGroup>
            </div>
        );
    }
}

const designatedContractorsIsApplicable = (coverage, type) => {
    if (type === 'oi' && VALID_BASE_COVERAGES.includes(coverage)) {
        return true;
    }
    return false;
};

export const getDesignateGCList = (
    ratings = {},
    coverage,
    type,
    submission,
    additionalCoverage,
    excessLimitAmount
) => {
    const newDesignatedGCList = [];
    const designatedGCMap = new Map();
    const designatedGCArray = Array.isArray(ratings.designatedContractors)
        ? ratings.designatedContractors
        : [];
    designatedGCArray.forEach(item => {
        designatedGCMap.set(item.key, item.completed);
    });

    if (designatedContractorsIsApplicable(coverage, type)) {
        ITEMS_NEEDED_TO_DESIGNATE_GC.forEach(item => {
            let condition = false; // some list items have a secondary condition that we need to check

            switch (item.key) {
                case 'DGC4':
                    if (
                        additionalCoverage &&
                        additionalCoverage.extendedCompletedOps &&
                        additionalCoverage.extendedCompletedOps.selected === true
                    ) {
                        condition = true;
                    }
                    break;
                case 'DGC5':
                case 'DGC6':
                if ((submission.projectAddress && submission.projectAddress.projectState === 'New York' && item.key === 'DGC5')
                || (submission.projectAddress && submission.projectAddress.projectState !== 'New York' && item.key === 'DGC6')) {
                   if (
                        (submission.exteriorDemo === 'true' || submission.exteriorDemo === true)
                        && (submission.demolitionDetailsInterior === 'false' || submission.demolitionDetailsInterior === false)
                    ) {
                        condition = true;
                    } else if (
                        !Number.isNaN(excessLimitAmount) &&
                        Number(excessLimitAmount) > 5000000
                    ) {
                        condition = true;
                    } else if (
                        submission.isVerticalExpansion === 'true' ||
                        submission.isVerticalExpansion === true
                    ) {
                        condition = true;
                    } else if (submission.occupancy === 'true' || submission.occupancy === true) {
                        condition = true;
                    } else if (
                        submission.exteriorWorkFiveStories === 'true' ||
                        submission.exteriorWorkFiveStories === true
                    ) {
                        condition = true;
                    } else if (
                        !Number.isNaN(submission.demolitionDetailsCost) &&
                        Number(submission.demolitionDetailsCost) >= 2000000
                    ) {
                        condition = true;
                    } else if (
                        !Number.isNaN(submission.totalCost) &&
                        Number(submission.totalCost) > 50000000
                    ) {
                        condition = true;
                    }
                }
                    break;
                default:
                    condition = true;
            }
            if (condition === true) {
                let completed = false;
                if (designatedGCMap.has(item.key)) {
                    completed = designatedGCMap.get(item.key);
                }
                newDesignatedGCList.push({
                    ...item,
                    completed: completed
                });
            }
        });
    }
    return newDesignatedGCList;
};

/**
 * This function will verify if Designated Contractors data is applicable and
 * return the updated designatedContractors array.  Rating values can be found in
 * submission.ratings.oi or pricingValues.
 *
 * @param {Object} ratingValues
 * @param {string} coverage
 * @param {string} type
 * @param {Object} submission
 * @param {Object} additionalCoverage
 * @param {string} excessLimitAmount

 */
export const getItemsNeededToDesignatedContractors = (
    ratingValues,
    baseCoverage,
    type,
    submission,
    additionalCoverage,
    excessLimitAmount
) => {
    // update with Designated Contractors if applicable.
    const designatedGCArray = getDesignateGCList(
        ratingValues,
        baseCoverage,
        type,
        submission,
        additionalCoverage,
        excessLimitAmount
    );
    if (Array.isArray(designatedGCArray) && designatedGCArray.length > 0) {
        return designatedGCArray;
    }
    return [];
};
